import { useState, useEffect } from 'react';
import { Gql } from '@fiverr-private/loyalty_utils';
import { BannerType, PayloadGigInfo } from './bannerPropsTypes';

export const useShouldShowBanner = ({
    gigInfo,
    loyaltyIndicationData,
    type,
}: {
    gigInfo: PayloadGigInfo;
    loyaltyIndicationData: Gql.EngagementBadgeInfo;
    type: BannerType;
}): boolean => {
    const [shouldShow, setShouldShow] = useState(false);

    useEffect(() => {
        if (!loyaltyIndicationData) {
            return;
        }

        const allTiers = Object.values(Gql.LoyaltyProgramTier);
        let show = false;

        if (allTiers.includes(loyaltyIndicationData.tier)) {
            show = true;
        }

        setShouldShow(show);
    }, [loyaltyIndicationData, gigInfo, type]);

    return shouldShow;
};
